import React, { useState, useCallback, useMemo } from "react";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";

const MapComponent = ({ height = "300px", latitude, longitude }) => {
  const libraries = useMemo(() => ["places"], []);
  const [map, setMap] = useState(null);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: import.meta.env.VITE_API_MAP_KEY,
    libraries,
  });

  const defaultCenter = { lat: 37.7749, lng: -122.4194 };

  // Compute center based on provided latitude and longitude
  const center = useMemo(() => {
    if (typeof latitude === "number" && typeof longitude === "number") {
      return { lat: latitude, lng: longitude };
    }
    return defaultCenter;
  }, [latitude, longitude]);

  const onLoad = useCallback((mapInstance) => {
    setMap(mapInstance);
  }, []);

  const onUnmount = useCallback(() => {
    setMap(null);
  }, []);

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading maps...</div>;

  return (
    <GoogleMap
      mapContainerStyle={{
        width: "100%",
        height: height,
      }}
      center={center}
      zoom={12}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      {typeof latitude === "number" && typeof longitude === "number" && (
        <Marker position={{ lat: latitude, lng: longitude }} />
      )}
    </GoogleMap>
  );
};

export default MapComponent;
